import axios from 'axios'
import {useCallback, useEffect, useRef, useState} from 'react'
import {useHistory, useParams} from 'react-router-dom'
import generatePDF, {Margin, Options, Resolution} from 'react-to-pdf'
import EmptyPageWidget from '../../../../global/widgets/EmptyPageWidget'
import {Container} from '../../../../modules/components'
import InternalNavigation from '../../../../modules/internalNavigation/InternalNavigation'
import ClinicDoctorInvoiceSubpage from './subpages/ClinicDoctorInvoiceSubpage'
import InfoClinicInvoiceSubpage from './subpages/InfoClinicInvoiceSubpage'
import ClinicConsultInvoiceSubpage from './subpages/ClinicConsultInvoiceSubpage'
import {GetInvoiceClinicByIdModel, GetInvoiceClinicSuccessModel} from './models'

export default function ShowClinicInvoice() {
    const {id}: {id: string} = useParams()
    const {clinicId}: {clinicId: string} = useParams()
    const [loading, setLoading] = useState(true)
    const [invoice, setStatement] = useState<GetInvoiceClinicSuccessModel>()
    const history = useHistory()
    const downloadRef = useRef<HTMLDivElement | null>(null)

    const getTargetElement = () => document.getElementById('download-reference')
    const options = {
        method: 'save',
        resolution: Resolution.NORMAL,
        page: {
            margin: Margin.NONE,
            format: 'A4',
            orientation: 'landscape',
        },
        canvas: {
            mimeType: 'image/jpeg',
            qualityRatio: 1,
        },
    }

    const getInvoice = useCallback(
        async (isUpdate = false) => {
            if (!invoice || isUpdate) {
                try {
                    const {data} = await axios.get<GetInvoiceClinicByIdModel>(
                        `/core/billing/invoices/clinics/${id}/show/${clinicId}`
                    )
                    setStatement(data.data)
                } catch {
                    history.goBack()
                } finally {
                    setLoading(false)
                }
            }
        },
        [invoice, id, clinicId, history]
    )

    const handleDownloadPDF = (invoice: GetInvoiceClinicSuccessModel) => {
        const element = downloadRef.current

        if (element) {
            // 1. Exibe o conteúdo removendo 'd-none'
            element.classList.remove('d-none')

            generatePDF(getTargetElement, {
                ...options,
                ...{
                    filename: `faturamento-estabelecimento-${invoice.clinic_invoice.reference_at.replaceAll(
                        '/',
                        '-'
                    )}`,
                },
            } as Options)

            element.classList.add('d-none')
        }
    }

    useEffect(() => {
        getInvoice()
    }, [getInvoice])

    return (
        <>
            <div className='row'>
                <Container loading={loading}>
                    {invoice !== undefined ? (
                        <>
                            <div className='col-lg-12 text-end'>
                                <button
                                    onClick={() => handleDownloadPDF(invoice)}
                                    className={`btn btn-sm btn-light-primary mb-2`}
                                >
                                    <i className={'fas fa-file-download'}></i>
                                    Baixar relatório
                                </button>
                            </div>
                            <InternalNavigation
                                labels={['Informações', 'Serviços', 'Repasses']}
                                pages={{
                                    info: (
                                        <InfoClinicInvoiceSubpage
                                            invoice={invoice.clinic_invoice}
                                        />
                                    ),
                                    consults: (
                                        <ClinicConsultInvoiceSubpage
                                            invoiceConsults={invoice.clinic_invoice_consults}
                                        />
                                    ),
                                    doctor: (
                                        <ClinicDoctorInvoiceSubpage
                                            invoiceDoctors={invoice.clinic_invoice_doctors}
                                        />
                                    ),
                                }}
                                titleSubmit='Cadastrar'
                                buttonNext={false}
                            />
                        </>
                    ) : (
                        <EmptyPageWidget code={404} title='Não encontrado' />
                    )}
                    {invoice !== undefined && (
                        <div className='d-none' ref={downloadRef} id='download-reference'>
                            <div className='mb-5'>
                                <InfoClinicInvoiceSubpage
                                    invoice={invoice.clinic_invoice}
                                    isExport={true}
                                />
                            </div>
                            <div className='mb-5'>
                                <ClinicConsultInvoiceSubpage
                                    invoiceConsults={invoice.clinic_invoice_consults}
                                    isExport={true}
                                />
                            </div>
                            <div>
                                <ClinicDoctorInvoiceSubpage
                                    invoiceDoctors={invoice.clinic_invoice_doctors}
                                    isExport={true}
                                />
                            </div>
                        </div>
                    )}
                </Container>
            </div>
        </>
    )
}
